"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterNavigator = void 0;
var legup_model_1 = require("@legup/legup-model");
var react_1 = __importDefault(require("react"));
var strings_1 = __importDefault(require("../strings"));
var utils_1 = require("../utils");
var Alert_1 = require("./Alert");
var LimitTextField_1 = require("./LimitTextField");
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var Collapse_1 = __importDefault(require("@material-ui/core/Collapse"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    card: {
        margin: theme.spacing(2),
    },
    sectionTitle: {
        fontSize: 20,
        fontWeight: 500,
    },
    instructions: {
        fontSize: 16,
        fontWeight: 700,
        fontStyle: "italic",
    },
    divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        height: 4,
    },
    toggleIcon: {
        display: "inline-block",
    },
}); });
var EnterNavigator = function (props) {
    var classes = useStyles(props);
    var _a = react_1.default.useState(""), email = _a[0], setEmail = _a[1];
    var _b = react_1.default.useState(false), validEmail = _b[0], setValidEmail = _b[1];
    var _c = react_1.default.useState(false), expandNavigator = _c[0], setExpandNavigator = _c[1];
    var _d = react_1.default.useState(false), hasConsent = _d[0], setHasConsent = _d[1];
    var _e = react_1.default.useState(), alertMessage = _e[0], setAlertMessage = _e[1];
    var onEmailChange = function (e) {
        setEmail(e.target.value);
        setValidEmail(utils_1.emailValidation(e.target.value));
    };
    var onVerify = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!hasConsent) return [3, 1];
                    setAlertMessage(strings_1.default.enterNavigator.errorConsent);
                    return [3, 3];
                case 1: return [4, checkNavigator()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2];
            }
        });
    }); };
    var checkNavigator = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, navigator_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, props.onCheckName(email)];
                case 1:
                    result = _a.sent();
                    if (result) {
                        navigator_1 = new legup_model_1.Navigator();
                        navigator_1.setId(result.navigator_id);
                        navigator_1.setName(result.name);
                        navigator_1.setAccess(result.access);
                        navigator_1.setEmail(email);
                        props.onSelected(navigator_1);
                    }
                    else {
                        setAlertMessage(strings_1.default.enterNavigator.errorUser);
                    }
                    return [2];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_1.default, { elevation: 0, key: "card-parent2", className: classes.card },
            react_1.default.createElement(CardContent_1.default, null,
                react_1.default.createElement(Grid_1.default, { container: true, direction: "row", alignItems: "center" },
                    react_1.default.createElement(Grid_1.default, { item: true },
                        react_1.default.createElement(Typography_1.default, { variant: "h2", className: classes.sectionTitle }, strings_1.default.enterNavigator.title)),
                    react_1.default.createElement(Grid_1.default, { item: true },
                        react_1.default.createElement(IconButton_1.default, { id: "expand-parent", className: classes.toggleIcon, onClick: function () { return setExpandNavigator(!expandNavigator); } }, expandNavigator ? react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faArrowUp }) : react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faArrowDown })))),
                react_1.default.createElement(Divider_1.default, { variant: "fullWidth", className: classes.divider }),
                react_1.default.createElement(Collapse_1.default, { in: expandNavigator, timeout: "auto", unmountOnExit: true },
                    react_1.default.createElement(Grid_1.default, { container: true, spacing: 2 },
                        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                            react_1.default.createElement(Typography_1.default, { className: classes.instructions }, strings_1.default.enterNavigator.instructions)),
                        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                            react_1.default.createElement(LimitTextField_1.LimitTextField, { id: "email", name: "email", key: "email", variant: "outlined", size: "small", label: strings_1.default.enterNavigator.labelEmail, fullWidth: true, limit: 100, showCount: false, value: email, onChange: onEmailChange })),
                        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                            react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { checked: hasConsent, onChange: function (e) { return setHasConsent(e.target.checked); }, name: "has_consent", color: "primary" }), label: react_1.default.createElement(Typography_1.default, { variant: "body1" }, strings_1.default.enterNavigator.labelConsent) })),
                        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                            react_1.default.createElement(Button_1.default, { key: "add", variant: "contained", color: "primary", fullWidth: true, onClick: onVerify, disabled: !validEmail }, strings_1.default.enterNavigator.buttonVerify)))))),
        react_1.default.createElement(Alert_1.Alert, { title: strings_1.default.enterNavigator.alertTitle, description: alertMessage, open: !!alertMessage, onClose: function () { return setAlertMessage(undefined); } })));
};
exports.EnterNavigator = EnterNavigator;
